// Centralized analytics helper.
// Fires events on GA4 (gtag) and Meta Pixel (fbq) when loaded.
// GTM + Meta Pixel are loaded lazily from env vars so they can be enabled
// per-environment without redeploying the whole site logic.

const GTM_ID = process.env.REACT_APP_GTM_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let initialized = false;

export const initAnalytics = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  // Google Tag Manager (only if REACT_APP_GTM_ID configured)
  if (GTM_ID && !window.__gtmLoaded) {
    window.__gtmLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(s);
  }

  // Meta (Facebook) Pixel — respects consent (loads only after user accepts)
  if (META_PIXEL_ID && !window.fbq) {
    const stored = safeLocalStorage("md_cookie_consent");
    const loadPixel = () => {
      if (window.fbq) return;
      /* eslint-disable */
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      /* eslint-enable */
      window.fbq("init", META_PIXEL_ID);
      window.fbq("track", "PageView");
    };
    if (stored === "accepted") loadPixel();
    // Listen for consent update (custom event we dispatch from CookieBanner)
    window.addEventListener("md:consent-accepted", loadPixel, { once: true });
  }
};

const safeLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

/**
 * Track a custom event across GA4 + Meta Pixel.
 * @param {string} name - event name (snake_case for GA4)
 * @param {object} [params]
 */
export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;
  // GA4
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
  // Meta Pixel: map common GA4 names to standard Pixel events
  if (typeof window.fbq === "function") {
    const pixelMap = {
      contact_form_submit: "Lead",
      cta_click: "InitiateCheckout",
    };
    const fbEvent = pixelMap[name];
    if (fbEvent) {
      window.fbq("track", fbEvent, params);
    } else {
      window.fbq("trackCustom", name, params);
    }
  }
};

export const trackConversion = (name, params = {}) => {
  trackEvent(name, { ...params, is_conversion: true });
};
